import ApiClient from './ApiClient';

class GlobalArticlesAPI extends ApiClient {
  constructor() {
    super('global_articles', { accountScoped: true });
  }

  getArticles() {
    return this.get();
  }

  getArticle(id) {
    return this.show(id);
  }
}

export default new GlobalArticlesAPI();
